package com.eladfinish.bible.contest.screens.randomVerse.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.utils.MyStringUtils

data class HiddenNames(
    val verseWithBlanks: String,
    val personRegexList: List<String>,
)

class HidePeopleNamesUsecase {

    /**
     * Replaces every match of [names] in [randomVerseStr] with a blank.
     *
     * A name is a line of an `assets/peopleNames` file, turned into a regular expression:
     * - A letter written without nikud matches that letter with any nikud and teamim; a letter
     *   written with nikud requires that nikud (teamim may follow it). No word boundary is added,
     *   so a name also matches after a prefix: וּלְאַבְרָהָם becomes "וּלְ____".
     * - `?` after a letter or a nikud sign makes it optional: `אַבְרָה?ם` is both אברם and אברהם.
     * - Other regex syntax passes through: `[־ ]`, `\b`, a look-behind at the very start of the
     *   name (`(?<!עֲ)שָׂרָה`, so that עֲשָׂרָה stays), a look-ahead.
     * - A look-ahead that keeps a longer word whole has to skip the nikud itself:
     *   `לוֹט(?![֑-ׇ]*ן)` hides לוֹט and leaves לוֹטָן. `֑-ׇ` is the Unicode
     *   range of the teamim and nikud signs (the same range as `MyStringUtils.getSiman()`).
     *   A plain `לוֹט(?!ן)` does not work: the kamatz after the tet is matched first and then
     *   given back, so the look-ahead is tried right after the tet, sees a kamatz rather than a
     *   nun, and the name matches anyway, leaving "____ָן".
     *
     * The names are applied in order, each on the result of the one before it.
     */
    fun getVerseWithHiddenNames(names: List<String>, randomVerseStr: String): HiddenNames {
//        String siman = (char) 1425 + "-" + (char) 1479 + "&&[^" + makaf + "]";
//        siman = "[@" + siman + "]";
//        String aleph_tav = "א-ת";
//        String ot = "[" + '.' + aleph_tav + "]"; // ot is an Hebrew letter or a dot
//        String not_alef_tav_space = "[^א-ת" + makaf + colonSplitter + "\\s]";
        var verseWithBlanks = randomVerseStr
        val personRegexList = mutableListOf<String>()
        names.forEach { name ->
            var start = 0
            if (name.startsWith("(")) { // for negative look-behind (see Sarah in Bereshit)
                start = name.indexOf(")") + 1
            }
//            String personRegex = name.substring(start).replaceAll("(" + ot + "(?:" + getSiman() + "\\??)*" + ")", "(?:$1@)");
//            personRegex = personRegex.replaceRegex("@", not_alef_tav_space + "*"); // @ for non-letter char.
            var personRegex = MyStringUtils.getRegexOfNikudOnLetters(name.substring(start))

//            Timber.v(name + " personRegex: " + personRegex);
            val stringBuilder = StringBuilder(personRegex.trim())
            if (start > 0) {
                //prepend negative look-behind (?<!A) before replacing
                stringBuilder.insert(0, name.take(start))
            }
            personRegex = stringBuilder.toString()
            personRegexList.add(personRegex)
            verseWithBlanks = verseWithBlanks.replaceRegex(regex = personRegex, replacement = StringConstants.BLANK_LABEL)
//            String reg = ".*?" + personRegex + ".*?";
//            Timber.v(name + " מופיע בפסוק- " + pickedVerse.matches(reg));
        }
        return HiddenNames(verseWithBlanks, personRegexList)
    }

}
